$(document).ready(function() {
    var nowTemp = new Date();
    var now = new Date(nowTemp.getFullYear(), nowTemp.getMonth(), nowTemp.getDate(), 0, 0, 0, 0);

    var checkout = $('#finishDateReport').datepicker({ format: 'MM yyyy', autoclose: true, minViewMode: 'months' });
    var checkin = $('#startDateReport').datepicker({ format: 'MM yyyy', autoclose: true, minViewMode: 'months' });


    $('#get-reports').click(function (event) {
        var startDateReport = $('#startDateReport');
        var finishDateReport = $('#finishDateReport');

        var mayPick = true;

        if (startDateReport.val() == '') {
            $(startDateReport)[0].focus();
            mayPick = false;
        } else if (finishDateReport.val() == '') {
            $(finishDateReport)[0].focus();
            mayPick = false;
            if (!mayPick) {
                event.preventDefault();
            }
        }
    });

  $('#download-freelancer-reports').click(function (event) {
    event.preventDefault();
    let files = getReportIds();
    if (files) {
      window.location.href = '/files/getArchive?file_ids=' + files
    }
  });

  function getReportIds() {
    let ids = [];
    $('input[class="select-report"]:checked').each(function () {
      ids.push($(this).data('id'));
    });
    return ids.join(',');
  }

  $('#select-all-reports').change(function (event) {
    event.preventDefault();
    $('.select-report').prop('checked', this.checked);
  });

    checkin.on('changeDate', function (ev) {
        if (ev.date.valueOf() > checkout.datepicker('getDate').valueOf()) {
            var newDate = new Date(ev.date);

            newDate.setMonth(newDate.getMonth() + 1);
            checkout.datepicker('setDate', newDate);
        }
        $('#finishDateReport')[0].focus();
    });
});
